<template>

<div class="main list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="getList('main')" v-focus>
			<div class="button action input-go" @click="getList('main')"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters">
		<label>Department</label>
		<select v-model="filters.department_id" @change="getList(1)">
			<option value="">Select...</option>
			<option v-for="(department, index) in departments" :value="department.department_id">{{ department.description }}</option>
		</select>
		<ul class="checkbox-group">
			<li>
				<span :class="['pointer', 'far', filters.no_profit ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('no_profit')"></span>
				<label>Missing Profit %</label>
			</li>
			<li v-if="getAdministratorFlag">
				<span :class="['pointer', 'far', filters.internal_use_only ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('internal_use_only')"></span>
				<label>Hidden</label>
			</li>
			<li v-else>
				<span :class="['pointer', 'far', filters.hidden ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('hidden')"></span>
				<label>Hidden</label>
			</li>
			<li v-if="!getAdministratorFlag">
				<span :class="['pointer', 'far', filters.not_taxable ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('not_taxable')"></span>
				<label>Not Taxable</label>
			</li>
			<li v-if="getAdministratorFlag">
				<span :class="['pointer', 'far', filters.inactive ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('inactive')"></span>
				<label>Inactive</label>
			</li>
			<li v-if="!getAdministratorFlag">
				<span :class="['pointer', 'far', filters.client ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('client')"></span>
				<label>Custom</label>
			</li>
		</ul>
		<div class="divider"></div>
        <div :class="['button', hasFilters ? 'neutral' : 'disabled']" @click="clearFilters(1)">Clear Filters</div>
        <div class="button action" @click="addItem()">Add Category</div>
        <div v-if="getDevEnvironment"  class="divider"></div>
        <div v-if="getDevEnvironment" class="extra-menu-item" @click="getList()">Reload List</div>
	</div>

	<div class="list">
	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>
	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list left">Department</th>
					<th class="list left">Category</th>
					<th class="list center">Profit %</th>
					<th class="list center">Hidden</th>
					<th class="list center">Call</th>
					<th v-if="!getAdministratorFlag" class="list center">Not Taxable</th>
					<th v-if="!getAdministratorFlag" class="list center">Custom</th>
				</tr>
			</thead>
			<tr v-for="(item, index) in list" class="clickable-list-item" @click="getItem(item)">
				<td class="list left">{{ item.department }}</td>
				<td class="list left">{{ item.category }}</td>
				<td class="list center">{{ item.profit_percent }}</td>
				<td class="list center"><i v-if="item.hidden" class="fas fa-check"></i></td>
				<td class="list center"><i v-if="item.call_to_order" class="fas fa-check"></i></td>
				<td v-if="!getAdministratorFlag" class="list center"><i v-if="item.not_taxable" class="fas fa-check"></i></td>
				<!-- <td class="list center"><i v-if="item.inactive == 1" class="fas fa-check"></i></td> -->
				<td v-if="!getAdministratorFlag" class="list center"><i v-if="item.client_id == client_id" class="fas fa-check"></i></td>
			</tr>
		</table>

	</div>

	<iframe id="download" src="" style="display: none;"></iframe>

	<div v-if="showModal" class="modal medium-modal">
		<div class="inner">
			<h2>{{ listDetail.caliber_id != 'new' ? 'Edit' : 'Add' }} A Category</h2>
			<div class="content">
				<label>Department</label>
				<select v-model="listDetail.department_id" :disabled="!userCanEdit">
					<option value="">Select...</option>
					<option v-for="(department, index) in departments" :value="department.department_id">{{ department.description }}</option>
				</select>
				<label>Category</label>
				<input type="text" v-model="listDetail.category" :disabled="!userCanEdit"/>
				<div v-if="!userCanEdit" class="note">This category belongs to the system and cannot be edited.</div>

				<div>
					<label class="checkbox" style="margin: 0 1em 0 0;">
						<input type="checkbox" v-model="listDetail.hidden" value="1">
						<span><i class="fas fa-check-circle"></i>Hide from Website</span>
					</label>
					<label class="checkbox" style="margin: 0 1em 0 0;">
						<input type="checkbox" v-model="listDetail.call_to_order" value="1">
						<span><i class="fas fa-check-circle"></i>Show products as "Call to Order"</span>
					</label>
					<label v-if="!getAdministratorFlag" class="checkbox" style="margin: 0 1em 0 0;" @click="showNotTaxableAlert = true">
						<input type="checkbox" v-model="listDetail.not_taxable" value="1">
						<span><i class="fas fa-check-circle"></i>Not Taxable</span>
					</label>
					<label class="checkbox">
						<input type="checkbox" v-model="listDetail.inactive" value="1" :disabled="!userCanEdit">
						<span :class="{ disabled: !userCanEdit }"><i class="fas fa-check-circle"></i>{{ listDetail.inactive == '1' ? 'Re' : 'De'}}activate</span>
					</label>
				</div>

				<div v-if="showNotTaxableAlert" class="note">
					<i class="fas fa-exclamation-triangle" style="color: orange;"></i> This action is not retro-active!<br>
					Changing category tax status will impact your Daily Cash Report and Taxable Item Report for report periods with sales in this category before this change.
				</div>

				<label>Profit Margin</label>
				<div class="one-three-columns align-items-baseline">
					<div>
						<number-input v-if="listDetail.profit" :decimals='1' v-model="listDetail.profit.profit_percent" :key="'profit_percent_' + listDetail.profit.profit_percent" />
					</div>
					<div>
						<div class="button neutral inline" @click="$router.push('/inventory/profit-margins/' + listDetail.category_id + '?return=' + $route.path)">Manage Profit Margins</div>
					</div>
				</div>

				<div class="message-overlay" v-if="modalMessage">
					<p>{{ modalMessage }}</p>
					<p v-if="modalSuccess"><i class="fa fa-check" /></p>
				</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="backToList()">Cancel</div>
				<div :class="['button', 'spaced', !canSave || saving ? 'disabled' : 'action']" @click="saveItem()">Save Category</div>
			</div>
		</div>
	</div>

	<message-modal v-if="message" :message="message" :loading="loading" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<help-popup :helpLink="{161:'Categories', 169:'Profit Margins'}" :tours="false"></help-popup>

</div>

</template>

<script>
import NumberInput from '@/components/NumberInput.vue'
import HelpPopup from '@/components/HelpPopup.vue'
export default {
	name: 'categories',
    components: {
		'number-input': NumberInput,
		'help-popup': HelpPopup
    },
	data() {
		return {
            loading: false,
			client_id: '',
			message: '',
			messageTimeout: 0,
			messageStatus: '',
			filters: {},
            departments: [],
			list: [],
			mergeList: [],
			paging: {},
			showModal: false,
			gettingExport: false,
			listDetail: {},
			exportMessage: '',
			exporting: false,
			saving: false,
			modalMessage: '',
			modalSuccess: false,
			showNotTaxableAlert: false
		}
	},
	created() {
		this.getDepartments()
		this.clearFilters()
	},
	computed: {
		canSave() {
			return this.listDetail.category && this.listDetail.department_id
		},
		userCanEdit() {
			return this.listDetail.client_id == this.client_id || this.getAdministratorFlag
		},
		hasFilters() {
			return this.filters.search_term || this.filters.department_id || this.filters.no_profit || this.filters.hidden || this.filters.not_taxable || this.filters.client
		}
	},
	methods: {
		clearFilters() {
			// if filters were initilaly set but currently empty, don't reload list
			if (this.filters.hasOwnProperty('search_term') && !this.hasFilters) {
				return
			}
			this.filters = {
				page: 1,
				search_term: '',
				department_id: '',
				no_profit: 0,
				hidden: 0,
				not_taxable: 0,
				client: 0,
				current_id: '',
				internal_use_only: 0,
				inactive: 0,
				do_export: 0
			}
			this.getList()
		},
        getDepartments() {
			this.apiCall({ destination: 'get_list_departments' }).then(obj => {
				this.departments = obj.departments
			}).catch(err => {
				console.log(err)
			})
        },
		getList(page) {
			if (this.loading) { return }
			if (page) {
				this.filters.page = page
			}
			this.loading = true
			this.message = 'Loading list...'
			this.apiCall({ destination: 'get_list_categories_paged', data: this.filters }).then(obj => {
				this.messageStatus = obj.status
				this.message = obj.message
				this.client_id = obj.client_id
				this.loading = false
				this.filters.page = 1
				if (this.filters.do_export) {
					this.filters.do_export = 0
					var outputFile = obj.file_name
					// accommodate live server filecache latency
					setTimeout(() => {
						document.getElementById("download").src = "//" + document.location.hostname + "/download.php?file_name=" + obj.file_name + "&output_file_name=" + outputFile
						this.exporting = false
						this.exportMessage = ''
					}, 1500)
				} else {
                    this.list = obj.categories
                    if (obj.paging) {
                        this.paging = obj.paging
                    }
				}
			}).catch(err => {
				console.log(err)
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		toggleFilter(which) {
			this.filters[which] = !this.filters[which]
			this.getList(1)
		},
		getItem(item) {
			if (this.loading) { return }
			this.loading = true
			this.message = 'Loading category...'
			this.showModal = true
			this.apiCall({ destination: 'get_item_category', data: { category_id: item.category_id } }).then(obj => {
				this.loading = false
				this.messageStatus = obj.status
				this.message = obj.message
				if (obj.status == 'success') {
					this.listDetail = obj.category
					this.filters.current_id = this.listDetail.category_id
				} else {
					this.modalMessage = obj.message
				}
			})
		},
		addItem() {
			this.listDetail = {
				category_id: 'new',
				client_id: this.client_id,
				department_id: '',
				description: '',
				profit: {
					profit_percent: ''
				},
				internal_use_only: 0,
				inactive: 0
			}
			this.showModal = true
		},
		saveItem() {
			if (this.saving) { return }
			this.saving = true
			this.modalSuccess = false
			this.modalMessage = ''
			this.apiCall({ destination: 'save_item_category', data: this.listDetail }).then(obj => {
				this.saving = false
				if (obj.status == 'success') {
					this.modalMessage = 'Category saved!'
					this.modalSuccess = true
					setTimeout(() => {
						this.backToList()
						this.getList()
						this.modalMessage = ''
					}, 2000);
				} else {
					this.modalMessage = obj.message
					setTimeout(() => { this.modalMessage = '' }, 2000);
				}
			}).catch(err => {
				console.log(err)
			})
		},
		backToList() {
			this.showModal = false
			this.current_id = ''
			this.listDetail = {}
		},
		doExport() {
			if (this.exporting) { return }
			this.exporting = true
			this.exportMessage = 'Generating CSV for ' + this.list.length + ' items...'
			this.filters.do_export = true
			this.getList()
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
